//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import SettleSetting from './components/settle-setting.vue';
import TableAuditTask from './components/table-audit-task.vue';
import DialogSettleSetting from './components/dialog-settle-setting.vue';

import { getValueByKey as getDwtypeByKey } from './data/dwtype.js';

export default {
    components: {
        SettleSetting,
        TableAuditTask,
        DialogSettleSetting,
    },
    props: {},
    data() {
        return {
            dwinfo: {},
            channelProductList: [],
            user: {},
        };
    },
    computed: {
        dwcode: function () {
            return this.getQuery('dwcode');
        },
    },
    watch: {},
    methods: {
        getDetail: function () {
            this.$get(this.$store.getters.partnerUrl + '/channelInfo/' + this.dwcode, {}, function (data) {
                this.dwinfo = data.dwinfo;
                this.channelProductList = data.channelProductList;

                if (data.user) {
                    this.user = data.user;
                }
            });
        },
        downloadFile: function (val) {
            window.open(val);
        },
        goBack: function () {
            this.$router.go(-1);
        },
        getDwtypeByKey,

        calcAuditStatus(key) {
            const statusMap = {
                0: {
                    label: '待审核',
                    type: 'primary',
                },
                1: {
                    label: '审核通过',
                    type: 'success',
                },
                2: {
                    label: '审核退回',
                    type: 'danger',
                },
            };

            return statusMap[key] || {};
        },
    },
    mounted: function () {
        this.getDetail();
    },
};
